(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-ticker"]) return;
  try {
    
  document.querySelectorAll('[data-omt-ticker]').forEach((ticker) => {
    const toggle = ticker.querySelector('[data-omt-ticker-toggle]');
    const label = ticker.querySelector('[data-omt-ticker-label]');
    toggle?.addEventListener('click', () => {
      const paused = ticker.classList.toggle('is-paused');
      toggle.setAttribute('aria-pressed', String(paused));
      if (label) label.textContent = paused ? label.dataset.resume : label.dataset.pause;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
